import React from 'react';
export function Footer() {
  return <footer className="bg-gray-900 text-gray-400 py-12 text-center text-sm" data-id="element-88">
      <div className="container mx-auto px-4" data-id="element-89">
        <p className="mb-4" data-id="element-90">© 2026 Edulabs. Todos los derechos reservados.</p>
        <p className="max-w-2xl mx-auto text-gray-600" data-id="element-91">
          Este sitio no forma parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio no está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}